import "./Footer.css";



const Footer = () => {

  return (
    <div id="footer">
      <div className="footer">
        <div className="ilike">
          <p>Если сайт Вам понравился и оказался для Вас полезным, то...</p>
          
          <div className="ilike_but_top">
          <p>Издание книги «Сын Люцифера»: 
          <br/><span style={{backgroundColor: 'rgb(255, 0, 255)', color: 'rgb(0, 255, 0)'}}
          >&nbsp;&nbsp;&nbsp;0 %&nbsp;&nbsp;&nbsp;</span></p>
          </div>

        </div>
        <div className="copy"><p>Все права защищены Ⓒ 2011-2025 Официальный сайт Сергея Мавроди</p></div>
      </div>
    </div>
  );
};

export default Footer;